// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS Component */

.TagInput-module__Container__qiE1K {
    display: flex;
    flex-direction: column;
    gap: var(--ds-s);
    align-items: flex-start;
    width: 100%;
}

.TagInput-module__LabelContainer__Mj4oN {
    display: flex;
    gap: var(--ds-xs);
    align-items: center;
    max-width: 100%;
}

.TagInput-module__LabelDisabled__ZpMIS {
    color: var(--ds-input-disabled-label-color);
}

.TagInput-module__DescriptionDisabled__XroVv {
    color: var(--ds-input-disabled-description-color);
}

.TagInput-module__InnerWrapper__wy52q {
    display: flex;
    flex-grow: 1;
    flex-wrap: wrap;
    gap: var(--ds-s);
    align-self: stretch;
    box-sizing: content-box;
    min-width: 0;
    padding: var(--ds-s);
    overflow-y: auto;
    background: var(--ds-input-field-bg-color);
    border-radius: var(--ds-border-radius-sm);
    box-shadow: 0 0 0 var(--ds-border-width) var(--ds-input-field-border-color)
        inset;
}

.TagInput-module__Disabled__VFcGw {
    background: var(--ds-input-field-disabled-bg-color);
    box-shadow: 0 0 0 var(--ds-border-width)
        var(--ds-input-field-disabled-border-color) inset;
}

.TagInput-module__InnerWrapper__wy52q:hover {
    box-shadow: 0 0 0 var(--ds-border-width)
        var(--ds-input-field-hover-border-color) inset;
}

.TagInput-module__Disabled__VFcGw:hover {
    box-shadow: 0 0 0 var(--ds-border-width)
        var(--ds-input-field-disabled-border-color) inset;
}

.TagInput-module__Focused__sH8Yg {
    box-shadow: 0 0 0 var(--ds-border-width-double)
        var(--ds-input-field-focused-border-color) inset;
}

.TagInput-module__Focused__sH8Yg:hover {
    box-shadow: 0 0 0 var(--ds-border-width-double)
        var(--ds-input-field-focused-border-color) inset;
}

.TagInput-module__Errored__dZ_42 {
    box-shadow: 0 0 0 var(--ds-border-width-double)
        var(--ds-input-field-error-border-color) inset;
}

.TagInput-module__Errored__dZ_42:hover {
    box-shadow: 0 0 0 var(--ds-border-width-double)
        var(--ds-input-field-error-border-color) inset;
}

.TagInput-module__Listbox__PBvmT {
    display: contents;
}

.TagInput-module__Input__ywjmH {
    all: unset;
    display: flex;
    flex: 1;
    min-width: 0;
    height: var(--ds-xl);
    padding: 0 var(--ds-xs);
    color: var(--ds-input-field-text-color);
    font-size: var(--ds-font-size-m);
}
/* TODO: https://lucidlink.atlassian.net/browse/LUCID-27887 */
/* stylelint-disable-next-line plugin/no-unsupported-browser-features -- Unexpected browser feature "css-autofill" is not supported by Firefox 147-148 */
.TagInput-module__Input__ywjmH:autofill,
.TagInput-module__Input__ywjmH:autofill:focus {
    transition:
        background-color 600000s 0s,
        color 600000s 0s;
}

.TagInput-module__Input__ywjmH:disabled {
    color: var(--ds-input-field-disabled-text-color);
    background-color: var(--ds-input-field-disabled-bg-color);
}

.TagInput-module__Input__ywjmH:disabled::placeholder {
    color: var(--ds-input-field-disabled-placeholder-color);
}

.TagInput-module__Input__ywjmH::placeholder {
    color: var(--ds-input-field-placeholder-color);
}

.TagInput-module__TagLi__oUW74 {
    min-width: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `TagInput-module__Container__qiE1K`,
	"LabelContainer": `TagInput-module__LabelContainer__Mj4oN`,
	"LabelDisabled": `TagInput-module__LabelDisabled__ZpMIS`,
	"DescriptionDisabled": `TagInput-module__DescriptionDisabled__XroVv`,
	"InnerWrapper": `TagInput-module__InnerWrapper__wy52q`,
	"Disabled": `TagInput-module__Disabled__VFcGw`,
	"Focused": `TagInput-module__Focused__sH8Yg`,
	"Errored": `TagInput-module__Errored__dZ_42`,
	"Listbox": `TagInput-module__Listbox__PBvmT`,
	"Input": `TagInput-module__Input__ywjmH`,
	"TagLi": `TagInput-module__TagLi__oUW74`
};
export default ___CSS_LOADER_EXPORT___;
